module.exports = __webpack_public_path__ + "img/yt-joe-pa.75647c11.png";